<style src="./Editor.scss" lang="scss"></style>

<template lang="pug">
  form.editor(
    :class='classList'
    @submit.prevent='() => {}'
  )
    .editor__header
      .editor__cover
        ImageUpload(
          :image='getCover()'
          :rounded='true'
          @update-cover='updateCover'
        )
      .editor__fields
        .editor__radiobuttons
          .editor__radiobutton
            Radiobutton(
              name='type'
              field-value='artist'
              v-model='form.type'
              :label='$l10n("ARTIST")'
            )
          .editor__radiobutton
            Radiobutton(
              name='type'
              field-value='group'
              v-model='form.type'
              :label='$l10n("GROUP")'
            )
        .editor__field
          Input(
            name='name'
            :required='true'
            :placeholder='$l10n("TITLE")'
            v-model='form.title'
          )
    .editor__body
      .editor__itemlist
        ItemList(
          title='Альбомы'
          type='albums'
          :items='albums'
          :editable='true'
          :review='true'
          :removable='true'
          :checkable='true'
          :empty-message='$l10n("YOU_DONT_HAVE_ALBUMS")'
          @checked='list => checkItems(list, "albums")'
        )
      .editor__itemlist
        ItemList(
          title='Синглы'
          type='albums'
          :items='singles'
          :editable='true'
          :review='true'
          :checkable='true'
          :removable='true'
          :empty-message='$l10n("YOU_DONT_HAVE_SINGLES")'
          @checked='list => checkItems(list, "singles")'
        )
    .editor__footer
      p.editor__text {{ $l10n("SAVE_OR_CANCEL_CHANGES") }}
      .editor__buttons
        .editor__button
          Button(
            @click='saveArtist'
            :label='$l10n("SAVE")'
            type='button'
            class-list='is-small is-rounded'
          )
        .editor__button
          Button(
            @click='cancel'
            :label='$l10n("CANCEL")'
            type='button'
            class-list='is-small is-bordered is-rounded is-grey'
          )
</template>

<script>
import { mapActions } from "vuex";

import ItemList from "@/components/ItemList/ItemList";
import Input from "@/components/Input/Input";
import Radiobutton from "@/components/Radiobutton/Radiobutton";
import Button from "@/components/Button/Button";
import ImageUpload from "@/components/ImageUpload/ImageUpload";
import Select from "@/components/Select/Select";

import editorMixin from "@/mixins/components/editor.mixin";

export default {
  props: {
    artist: {
      type: Object,
      required: true
    },
    albums: {
      type: Array,
      default: () => []
    },
    singles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      initialForm: this.getForm(),
      form: this.getForm(),
      checked: {
        albums: [],
        singles: []
      }
    };
  },
  components: {
    ItemList,
    Input,
    Radiobutton,
    Button,
    ImageUpload,
    Select
  },
  mixins: [editorMixin],
  methods: {
    ...mapActions({
      save: "personal/save"
    }),
    updateCover(images = []) {
      if (images.length) {
        try {
          this.form.image = images[0].file;
          this.hasChanges = true;
        } catch (error) {
          this.form.image = null;
        }
      }
    },
    checkItems(list = [], type) {
      this.checked[type] = [...list];
      this.form.deleted = [...this.checked.singles, ...this.checked.albums];
    },
    getCover() {
      if (this.artist !== null && this.artist.cover) {
        return this.artist.cover.medium;
      }

      return null;
    },
    getForm() {
      return {
        title: this.artist.title || this.$l10n("NO_NAME"),
        image: null,
        type: this.artist.type || "artist",
        deleted: []
      };
    },
    getCreator(type) {
      switch (type) {
        case "single":
          return {
            title: this.$l10n("ADD_SINGLE"),
            label: null,
            href: "/albums/create?type=singles"
          };
        case "album":
          return {
            title: this.$l10n("ADD_ALBUM"),
            label: null,
            href: "/albums/create"
          };

        default:
          return null;
      }
    },
    async saveArtist() {
      if (this.hasChanges) {
        let accessed = true;

        if (this.form.deleted.length) {
          const { confirm = false } = await this.openModal({
            name: "confirm",
            data: {
              title: this.$l10n("CONTINUE"),
              caption: this.$l10n("SELECTED_ALBUMS_WILL_DELETED")
            }
          });

          accessed = confirm;
        }

        if (accessed) {
          this.loading = true;
          this.hasChanges = false;

          await this.save(this.form);

          this.loading = false;
        }
      } else {
        this.$router.push("/profile");
      }
    }
  }
};
</script>
